/** KDS Tabs — line variant + brand palette. */
export const tabsVariant = 'line' as const;
export const tabsColorPalette = 'brand';

/** Tab list baseline — Figma `border-b` on the trigger row. */
export const tabsListBorderWidth = '1px';

/** Active tab underline — Figma `border-b` on selected trigger (Chakra default is 2px). */
export const tabsIndicatorThickness = '1px';

/** Overlap active indicator with the list baseline. */
export const tabsIndicatorOffsetY = '-1px';
